var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SelectComponent',_vm._b({attrs:{"value":_vm.value && _vm.value.toString(),"items":[
    { value: 'true', label: _vm.$tc('yes') },
    { value: 'false', label: _vm.$tc('no') },
  ]},on:{"input":$ev => _vm.$emit('input', $ev === 'true' ? true : false)}},'SelectComponent',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }